import { c as _c } from "react/compiler-runtime";
import { requestIdleCallback } from '@cc-shopping/utils/requestIdleCallback';
import { Box } from '@mui/material';
import { useShallow } from 'zustand/shallow';
import { initialFilterState } from '../../store';
import { useOffersFilterStore } from '../../store/Context';
import type { FilterType } from '../../store/enums';
import { useFiltersAnalytics } from '../../store/hooks/useFiltersAnalytics';
import type { OffersFilterStoreState } from '../../store/types';
import { Pill } from './Pill';
export function AppliedFiltersSummary() {
  const $ = _c(13);
  const {
    filterFormState,
    handleApplyFilters,
    handleSingleFormUpdate,
    selectedNonDefaultFilters
  } = useOffersFilterStore(useShallow(_temp));
  const {
    firePillsRemovalEvents
  } = useFiltersAnalytics();
  if (selectedNonDefaultFilters.length === 0) {
    return null;
  }
  let t0;
  if ($[0] !== filterFormState || $[1] !== firePillsRemovalEvents || $[2] !== handleApplyFilters || $[3] !== handleSingleFormUpdate) {
    t0 = (type, value, label) => {
      const completeValue = filterFormState[type];
      if (Array.isArray(completeValue)) {
        const newValue = completeValue.filter(item => item !== value);
        handleSingleFormUpdate({
          value: newValue,
          type
        });
      } else {
        handleSingleFormUpdate({
          value: initialFilterState[type],
          type
        });
      }
      requestIdleCallback(() => {
        handleApplyFilters();
        firePillsRemovalEvents(label);
      });
    };
    $[0] = filterFormState;
    $[1] = firePillsRemovalEvents;
    $[2] = handleApplyFilters;
    $[3] = handleSingleFormUpdate;
    $[4] = t0;
  } else {
    t0 = $[4];
  }
  const handleFilterRemoval = t0;
  let t1;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      display: "flex",
      gap: 2,
      flexWrap: "wrap"
    };
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== handleFilterRemoval || $[7] !== selectedNonDefaultFilters) {
    let t3;
    if ($[9] !== handleFilterRemoval) {
      t3 = t4 => {
        const {
          type: type_0,
          label: label_0,
          value: value_0
        } = t4;
        return <Pill key={value_0} onClick={() => handleFilterRemoval(type_0, value_0, label_0)}>{label_0}</Pill>;
      };
      $[9] = handleFilterRemoval;
      $[10] = t3;
    } else {
      t3 = $[10];
    }
    t2 = selectedNonDefaultFilters.map(t3);
    $[6] = handleFilterRemoval;
    $[7] = selectedNonDefaultFilters;
    $[8] = t2;
  } else {
    t2 = $[8];
  }
  let t3;
  if ($[11] !== t2) {
    t3 = <Box sx={t1}>{t2}</Box>;
    $[11] = t2;
    $[12] = t3;
  } else {
    t3 = $[12];
  }
  return t3;
}
function _temp(state) {
  return {
    filterFormState: state.filterFormState,
    handleApplyFilters: state.handleApplyFilters,
    handleSingleFormUpdate: state.handleSingleFormUpdate,
    selectedNonDefaultFilters: state.selectedNonDefaultFilters
  };
}